import { useMutation } from "@tanstack/react-query";
import { queryClient } from "../../..";
import { BotijaoModulo } from "../types/Botijao";
import Swal from 'sweetalert2'
import { api } from "../../../infra/api";
import { URLS } from "../../../infra/URLS";

export default function usePutProdutos(onSuccess: () => void) {
  return useMutation(({botijaoAtual, id, data} : {botijaoAtual : BotijaoModulo, id : number, data : BotijaoModulo}) => 
  {
    //@ts-ignore
    Object.keys(data as any).forEach((key: string) => data[key] === undefined && delete data[key])

    Object.assign(botijaoAtual, data)
  
    return api.put(`${URLS.BOTIJAO_API}/${id}`, botijaoAtual)
      .then((response: any) => {
        console.log(response)
        Swal.fire({
          title: "Botijão Editado",
          text: "O botijão foi editado com sucesso!",
          icon: "success",
          position: "center",
          confirmButtonText: "OK",
          confirmButtonColor: "#349946",
          allowOutsideClick: false
        }).then(() => {
          onSuccess();
          queryClient.invalidateQueries();
        })
      })
      .catch((err: any) => {
        err.response.status === 500 ?
          Swal.fire({
            title: `Erro de status ${err.response.status}`,
            text: `Ocorreu um erro interno ao editar o botijão. Por favor, entre em contato com um administrador do sistema.`,
            icon: "error",
            position: "center",
            confirmButtonText: "OK",
            confirmButtonColor: "#F27474",
            allowOutsideClick: false
          })
        :
          Swal.fire({
            title: "Erro ao editar o botijão",
            text: err.response.data.message,
            icon: "error",
            position: "center",
            confirmButtonText: "OK",
            confirmButtonColor: "#F27474",
            allowOutsideClick: false
          });
      }
    )
  })
}
